import { createContext } from "react";
import { InfrastructureDetailsDataType } from "pages/InfrastructureDetails/InfrastructureDetails.d";

export default createContext<InfrastructureDetailsDataType | undefined>(undefined);
